define(['jquery', 'core/ajax', 'core/notification', 'core/templates',
  'core/modal_factory',
  'core/modal_events',
  'jquery-validation',
  'sweetalert2'],
  function ($, ajax, notification, templates, ModalFactory,  ModalEvents, Swal) {
    return {
        init: function() {
            $(document).ready(function() {
                var popupview = $('#renewpopup').val();
                if(popupview == 1){
                    Swal.fire("Subscription expired!", "Please subscribe to access your account.", "warning");
                }
            });
        }
    };
});